'use client';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, ROUTE_TYPES, ROUTES } from '@/constants';
import { useGlobalStore } from '@/stores/GlobalStore';

export const ClientSideBanner = ({ className }: { className: string }) => {
  const routeType = useGlobalStore((state) => state.currentRouteType);

  const bannerImageObj = (() => {
    switch (routeType) {
      case ROUTE_TYPES.DONATION:
        return {
          url: BANNER_IMAGE_S3_URLS.DONATION,
          href: ROUTES.HOME.pathname,
        };
      default:
        return {
          url: BANNER_IMAGE_S3_URLS.WELLO,
          href: `${DONATION_ROUTES.HOME.pathname}?utm_source=web&utm_medium=banner&utm_campaign=jeju_event&utm_content=donation_event_2026`,
        };
    }
  })();

  return (
    <CustomLink className={className} href={bannerImageObj.href ?? '#'}>
      <Image fill alt="정책" loading="eager" src={bannerImageObj.url} sizes="240px" />
    </CustomLink>
  );
};

export const ClientSideQRCode = ({
  qrCodeUrl,
  width,
  height,
}: {
  qrCodeUrl: string;
  width: number;
  height: number;
}) => {
  const IMAGE_PLACEHOLDER = '/assets/pngs/placeholder.png';

  return (
    <Image
      alt="QR코드"
      height={height}
      loading="lazy"
      src={qrCodeUrl}
      width={width}
      onError={(e) => {
        e.currentTarget.src = IMAGE_PLACEHOLDER;
      }}
    />
  );
};

const BANNER_IMAGE_S3_URLS = {
  WELLO:
    'https://cdn.welfarehello.com/static/banner/aside-section-banner-wello.png',
  DONATION:
    'https://cdn.welfarehello.com/static/banner/aside-section-banner-donation.png',
};
